import { createSelector } from 'reselect';

import { LayerId } from 'yeself-common/typings/guide/LayerCommon';
import { RULE_TYPE } from 'yeself-common/enum/RuleEnum';
import { RulesDefinitionsItem } from 'yeself-common/typings/Rules';

const getLayersData = (state) => state.applicationDetail.guides.data;

const getLayerDataById = (state, id: LayerId) =>
    getLayersData(state).find((layer) => layer.id === id) || {};

export const makeSelectLayerType = () => createSelector([getLayerDataById], ({ type }) => type);

export const makeSelectLayerGraph = () => createSelector([getLayerDataById], ({ graph = {} }) => graph);

export const makeSelectLayerGraphMetadata = () =>
    createSelector([makeSelectLayerGraph()], ({ metadata = {} }) => metadata);

export const makeSelectIsLayerWithRelatedRule = () =>
    createSelector(
        [makeSelectLayerGraphMetadata()],
        ({ rulesDefinition = { visitor: [], identity: [] } }) =>
            Object.values(rulesDefinition).some((rules: RulesDefinitionsItem[] = []) =>
                rules.some(
                    ({ type }) =>
                        type === RULE_TYPE.COMPLETED_RELATED_GUIDE ||
                        type === RULE_TYPE.FINISHED_RELATED_GUIDE ||
                        type === RULE_TYPE.SEEN_RELATED_GUIDE ||
                        type === RULE_TYPE.HAS_NOT_SEEN_RELATED_GUIDE
                )
            )
    );
